import ApiClient from "@/api/ApiClient.ts";

const state = {
  remittances: [],
};

const mutations = {
  setRemittances(state, remittances) {
    state.remittances = remittances;
  },
};

const actions = {
  async getRemittances() {
    let remittances = [];
    for (let index = 0; index < 300; index++) {
      remittances.push({
        id: 1 + index,
        name: `Remesa enero 2021 id: ${1 + index}`,
        dateFrom: 1609455600,
        dateTo: 1612133940,
        subscribers: [1, 16],
      });
    }
    return remittances;
  },

  async getRemittanceById() {
    let invoices = [];
    for (let index = 0; index < 300; index++) {
      invoices.push({
        id: 1 + index,
        subscriberRef: 1184 + index,
        subscriberName: "Mutua universal de Vizcaya",
        taxBase: 100,
        VATamount: 21,
        totalDue: 121,
        invoiceNumber: 1182 + index,
      });
    }
    return invoices;
  },

  async getRemittanceInvoiceById() {
    return {
      invoicesSeries: "ASD",
      invoiceNumber: 1174,
      invoiceDate: "26/01/2021",
      issuerTradeName: "Radio Taxi Villa de Jovellanos servicios y transportes, S.L.",
      issuerVATnumber: "B12345678",
      issuerContactPhone: "985164444",
      issuerContactEmail: "info@radiotaxivilladejovellanos.com",
      issuerPostalAddressLine1: "Calle Orán 111, bajo A, oficina 4",
      issuerPostalAddressLine2: "33211 Gijón (Asturias)",
      issuerBankIBAN: "ES00 0000 0000 00 0000000000",
      issuerCommercialRegister:
        "Inscrita en el Registro Mercantil de Asturias, al libro 1786, tomo 18, hoja 175, e incripción primera",
      customerTradeName: "Radio Televisión de España, S.A.",
      customerVATnumber: "A12345678",
      customerContactPhone: "911234567",
      customerContactEmail: "info@rtve.es",
      customerPostalAddressLine1: "Edif. Prado del Rey. Avda. Radio Televisión, 4",
      customerPostalAddressLine2: "28223 POZUELO DE ALARCON (MADRID)",
      customerPaymentMethod: "Transferencia bancaria",
      configs: {
        invoiceLines: 1,
        linePrice: 1,
      },
      productLines: [
        {
          tripID: 286523,
          tripDate: "26/01/2021",
          tripStartTime: "08:35",
          tripEndTime: "09:24",
          taxi: "133",
          originAddress: "Avenida de Hola Hola 33",
          destinationAddress: "Calle de que pasa 44",
          originNotes: "En un lugar de la Mancha de cuyo nombre no quiero acordarme",
          stage1: "Notas de la primera etapa",
          stage2: "Notas de la segunda etapa",
          stage3: "Notas de la tercera etapa",
          stage4: "Notas de la cuarta etapa",
          stage5: "Notas de la quinta etapa",
          stage6: "Notas de la sexta etapa",
          stage7: "Notas de la septima etapa",
          stage8: "Notas de la octava etapa",
          stage9: "Notas de la novena etapa",
          stage10: "Notas de la decima etapa",
          kms: 87,
          authorizer: "Manola Jiménez",
          authorized: "Manolete Jiménez",
          productTaxBaseBreakdown: 2107 / 100,
          productDiscountBreakdown: 0,
          productVATamountBreakdown: 443 / 100,
          productAmountBreakdown: 2559 / 100,
          productColumnPrice: 2107,
        },
        {
          tripID: 286524,
          tripDate: "27/01/2021",
          tripStartTime: "10:30",
          tripEndTime: "11:45",
          taxi: "134",
          originAddress: "Avenida de Hola Hola 33",
          destinationAddress: "Calle de que pasa 44",
          originNotes: "En un lugar de la Mancha de cuyo nombre no quiero acordarme",
          stage1: "Notas de la primera etapa",
          stage2: "Notas de la segunda etapa",
          stage3: "Notas de la tercera etapa",
          stage4: "Notas de la cuarta etapa",
          stage5: "Notas de la quinta etapa",
          stage6: "Notas de la sexta etapa",
          stage7: "Notas de la septima etapa",
          stage8: "Notas de la octava etapa",
          stage9: "Notas de la novena etapa",
          stage10: "Notas de la decima etapa",
          kms: 87,
          authorizer: "Manola Jiménez",
          authorized: "Manolete Jiménez",
          productTaxBaseBreakdown: 2107 / 100,
          productDiscountBreakdown: 0,
          productVATamountBreakdown: 443 / 100,
          productAmountBreakdown: 2559 / 100,
          productColumnPrice: 2107,
        },
      ],
      taxBase: 218677,
      VATamount: 45922,
      fiscalRetention: 0,
      totalDue: 264599,
    };
  },

  async createRemittance(_, data) {
    try {
      let response = await ApiClient().post("subscribers/remittances", data);
      return response.data;
    } catch (error) {
      console.error("ERROR en createRemittance: ", error.message);
    }
  },

  async deleteRemittance(_, params) {
    try {
      await ApiClient().delete("subscribers/remittances", { params });
      return true;
    } catch (error) {
      return false;
    }
  },
};

const getters = {
  remittances(state) {
    return state.remittances;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
